import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { MessageToSupplier } from './message-to-supplier.model';

@Injectable()
export class MessageToSupplierService {

  constructor(private http: HttpClient) { }


}
